module.exports = __webpack_public_path__ + "img/HC1026-74.4364a18d.jpg";